import { render, staticRenderFns } from "./PaymentCorrection.vue?vue&type=template&id=6b52f99b"
import script from "./PaymentCorrection.vue?vue&type=script&lang=js"
export * from "./PaymentCorrection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports